import AddressSettingsForm from "../../components/Settings/AddressSettingsForm";
import NavSettings from "../../components/common/NavSettings";

const AddressSettings = () => {
  return (
    <>
      <NavSettings title="Mi perfil" route="Inicio" active="Direcciones" />

      <AddressSettingsForm />
    </>
  );
};

export default AddressSettings;
